module.exports = __webpack_public_path__ + "img/awaitOrder@2x.ff4f4ba2.png";